import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider as StoreProvider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { Settings } from "luxon";

import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import store, { persistor } from "./store/store";
import Loader from "./molecules/Loader";
import ThemeApp from "./theme/ThemeApp";
import config from "./config";

Settings.defaultLocale = "zh-CN";

console.debug("Loaded config:", config);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Router basename={config.SUB_DIRECTORY}>
      <StoreProvider store={store}>
        <PersistGate persistor={persistor} loading={<Loader />}>
          <ThemeApp />
        </PersistGate>
      </StoreProvider>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
